import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const getComment = (id) => {
    return api.post(`${ApiEndpointConstants.GET_COMMENT}`,{id})
}